(function () {
  'use strict';
  window.HealthyQuotePDF = function (quote, lead, settings) {
    const doc = new window.jspdf.jsPDF({unit:'pt',format:'a4',compress:true});
    const width = 595.28, height = 841.89, margin = 44, content = width - margin * 2;
    let y = margin;
    const plain = value => {
      const element = document.createElement('div');
      element.innerHTML = String(value || '').replace(/<\/(p|li|h[1-6])>/gi, '\n').replace(/<br\s*\/?\s*>/gi,'\n');
      return (element.textContent || '').replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g,'').replace(/[\u2010-\u2015]/g,'-');
    };
    const money = value => new Intl.NumberFormat('en-US',{style:'currency',currency:quote.currency || 'USD'}).format(value/100);
    function room(space) { if (y + space > height - 58) { doc.addPage(); y = margin; } }
    function text(value, size, bold, gap) {
      doc.setFont('helvetica',bold?'bold':'normal');doc.setFontSize(size);doc.setTextColor(80,66,51);
      const lines=doc.splitTextToSize(plain(value),content);
      lines.forEach(line=>{room(size*1.5);doc.text(line,margin,y+size);y+=size*1.5;});
      y+=gap || 0;
    }
    function rule() {room(14);doc.setDrawColor(225,218,209);doc.line(margin,y,width-margin,y);y+=14;}
    function row(label, amount, bold) {
      doc.setFont('helvetica',bold?'bold':'normal');doc.setFontSize(11);doc.setTextColor(80,66,51);
      const lines=doc.splitTextToSize(plain(label),content-125);
      lines.forEach((line,i)=>{room(18);doc.text(line,margin,y+11);if(i===0)doc.text(money(amount),width-margin,y+11,{align:'right'});y+=18;});
      y+=4;
    }
    text(settings.pdf_brand || 'Healthy Italia',22,true,5);
    text(settings.pdf_title || 'Private event quote',15,false,5);
    text(new Intl.DateTimeFormat('en-US',{dateStyle:'long'}).format(new Date()),10,false,16);
    rule();
    text(lead.name,12,true,2);text(lead.email,10,false,2);text(lead.phone,10,false,16);
    text(quote.packageTitle || quote.packageName,16,true,4);
    text(settings.guest_label + ' ' + quote.headcount,11,false,3);
    text(quote.packageDetail,10,false,16);
    if (quote.extraDetails && quote.extraDetails.length) {
      text(settings.addons_heading,13,true,6);
      quote.extraDetails.forEach(line=>row(line.title + ' (' + line.quantity + ' x ' + money(line.unitAmount) + ')',line.amount,false));
      y+=10;
    }
    room(250);rule();
    ['base','guests','addons','subtotal','service','tax'].forEach(key=>{
      const label=settings[key==='guests'?'guests_line':key+'_label'];
      const rate=key==='service'?quote.serviceRate:key==='tax'?quote.taxRate:null;
      row(label + (rate==null?'':' ('+rate+'%)'),quote.totals[key],key==='subtotal');
    });
    rule();row(settings.total_label,quote.totals.total,true);row(settings.each_label,quote.totals.each,true);
    y+=16;text(settings.notice,10,false,0);
    const pages=doc.getNumberOfPages();
    for(let i=1;i<=pages;i++){doc.setPage(i);doc.setFont('helvetica','normal');doc.setFontSize(9);doc.setTextColor(120);doc.text(i+' / '+pages,width-margin,height-27,{align:'right'});}
    doc.setProperties({title:settings.pdf_title || 'Private event quote',author:settings.pdf_brand || 'Healthy Italia'});
    return doc;
  };
})();
